import classNames from 'classnames'
import Link from 'next/link'
import { FollowingTab } from 'shared/types/Following'

type FollowingNavigateBarProps = {
  username: string
  activeTab: FollowingTab
  shouldShowMutualTab: boolean
}

const FollowingNavigationBar = (props: FollowingNavigateBarProps) => {
  const { username, activeTab, shouldShowMutualTab } = props

  return (
    <div className="inline-block px-7 lg:px-0">
      <div className="inline-flex w-full items-center justify-start gap-4 text-sm font-semibold lg:sticky lg:left-0 lg:top-28 lg:min-h-[116px] lg:min-w-[224px] lg:flex-col lg:justify-evenly lg:gap-0 lg:rounded-[40px] lg:border lg:border-black/10 lg:text-xl lg:font-normal">
        <FollowingNavigationBarItem
          itemLabel="Followers"
          navigateLink={`/${username}/followers`}
          isItemActive={activeTab === 'followers'}
          hasBottomBorder
        />
        <FollowingNavigationBarItem
          itemLabel="Following"
          navigateLink={`/${username}/following`}
          isItemActive={activeTab === 'following'}
          hasBottomBorder={shouldShowMutualTab}
        />

        {shouldShowMutualTab && (
          <FollowingNavigationBarItem
            itemLabel="Mutual"
            navigateLink={`/${username}/mutual`}
            isItemActive={activeTab === 'mutual'}
          />
        )}
      </div>
    </div>
  )
}

type FollowingNavigationBarItemProps = {
  navigateLink: string
  isItemActive: boolean
  hasBottomBorder?: boolean
  itemLabel: string
}

const FollowingNavigationBarItem = (props: FollowingNavigationBarItemProps) => {
  const { navigateLink, isItemActive, hasBottomBorder, itemLabel } = props
  return (
    <Link
      passHref
      href={navigateLink}
      className={classNames(
        'py-2 text-black/40 underline hover:underline lg:w-full lg:px-5 lg:py-3 lg:text-start lg:text-xl lg:text-black lg:no-underline lg:hover:no-underline',
        isItemActive && '!text-black lg:font-semibold',
        hasBottomBorder && 'lg:border-b lg:border-black/10',
      )}
    >
      {itemLabel}
    </Link>
  )
}

export default FollowingNavigationBar
